import { Action, action } from 'easy-peasy';

export interface AbaPendenciaModel {
  isVisible: boolean;
  show: Action<AbaPendenciaModel>;
  dismiss: Action<AbaPendenciaModel>;
}

const abaPendencia: AbaPendenciaModel = {
  isVisible: false,
  show: action(state => {
    state.isVisible = true;
  }),
  dismiss: action(state => {
    state.isVisible = false;
  }),
};

export default abaPendencia;
